var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCfacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.429,
    height: 23.935,
    viewBox: "0 0 12.429 23.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M45.358,23.935V13.018h3.663l.55-4.256H45.358V6.045c0-1.232.341-2.071,2.109-2.071h2.252V.167A30.532,30.532,0,0,0,46.437,0c-3.249,0-5.473,1.983-5.473,5.624V8.762H37.29v4.256h3.674V23.935Z",
    transform: "translate(-37.29)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfacebook);
export default __webpack_public_path__ + "static/media/cfacebook.39602e6eb2995a05fdf6b3793b3242d3.svg";
export { ForwardRef as ReactComponent };